<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="Ad_N"><section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="LOVE"><h1 class="chapter2" id="pz16-1"><a href="#/contents#ba_03" id="ab_03"><b>LOVE</b></a></h1>
<p id="pz16-3">But God demonstrates His own love toward us, in that while we were still sinners, Christ died for us.</p>
<p class="right" id="pz16-4"><em>Romans 5:8</em></p>
<p id="pz16-5">For God so loved the world that He gave His only begotten Son, that whoever believes in Him should not perish but have everlasting life.</p>
<p class="right" id="pz16-6"><em>John 3:16</em></p>
<p id="pz16-7">Beloved, let us love one another, for love is of God; and everyone who loves is born of God and knows God.</p>
<p id="pz16-8">He who does not love does not know God, for God is love.</p>
<p id="pz16-9">In this the love of God was manifested toward us, that God has sent His only begotten Son into the world, that we might live through Him.</p>
<p id="pz16-10">In this is love, not that we loved God, but that He loved us and sent His Son to be the propitiation for our sins.</p>
<p id="pz16-11">Beloved, if God so loved us, we also ought to love one another.</p>
<p id="pz16-12">No one has seen God at any time. If we love <span id="z17-1">one another, God abides in us, and His love has been perfected in us. </span></p>
<p class="right" id="pz17-2"><em>1 John 4:7–12</em></p>
<p id="pz17-3">And we have known and believed the love that God has for us. God is love, and he who abides in love abides in God, and God in him.</p>
<p id="pz17-4">We love Him because He first loved us.</p>
<p class="right" id="pz17-5"><em>1 John 4:16, 19</em></p>
<p id="pz17-6">As the Father loved Me, I also have loved you; abide in My love.</p>
<p id="pz17-7">If you keep My commandments, you will abide in My love, just as I have kept My Father’s commandments and abide in his love.</p>
<p id="pz17-8">These things I have spoken to you, that My joy may remain in you, and that your joy may be full.</p>
<p id="pz17-9">This is My commandment, that you love one another as I have loved you.</p>
<p id="pz17-10">Greater love has no one than this, than to lay down one’s life for his friends.</p>
<p id="pz17-11">These things I command you, that you love one another.</p>
<p class="right" id="pz17-12"><em>John 15:9–13, 17</em></p>
<p id="pz18-1">That Christ may dwell in your hearts through faith; that you, being rooted and grounded in love,</p>
<p id="An5">may be able to comprehend with all the saints what is the width and length and depth and height—</p>
<p id="pz18-2">to know the love of Christ which passes knowledge; that you may be filled with all the fullness of God.</p>
<p class="right" id="pz18-3"><em>Ephesians 3:17–19</em></p>
<p id="pz18-4">I love those who love me, and those who seek me diligently will find me.</p>
<p class="right" id="pz18-5"><em>Proverbs 8:17</em></p>
<p id="pz18-6">The L<span class="smallcaps">ORD</span> has appeared of old to me, saying:</p>
<p id="pz18-7">“Yes, I have loved you with an everlasting love;</p>
<p id="pz18-8">Therefore with lovingkindness I have drawn you.”</p>
<p class="right" id="pz18-10"><em>Jeremiah 31:3</em></p>
<p id="pz18-11">I will betroth you to Me forever;</p>
<p id="pz18-12">Yes, I will betroth you to Me in righteousness and justice,</p>
<p id="pz18-13">In lovingkindness and mercy.</p>
<p class="right" id="pz18-14"><em>Hosea 2:19</em></p>
<p id="pz19-1">He who has My commandments and keeps them, it is he who loves Me. And he who loves Me will be loved by My Father, and I will love him and manifest Myself to him.</p>
<p class="right" id="pz19-2"><em>John 14:21</em></p>
<p id="pz19-3">The L<span class="smallcaps">ORD</span> will command his lovingkindness in the daytime,</p>
<p id="pz19-4">And in the night His song shall be with me—</p>
<p id="pz19-5">A prayer to the God of my life.</p>
<p class="right" id="pz19-6"><em>Psalm 42:8</em></p>
<p id="pz19-7">And now abide faith, hope, love, these three; but the greatest of these is love.</p>
<p class="right" id="pz19-8"><em>I Corinthians 13:13</em></p>
<p id="pz19-9">For I am persuaded that neither death nor life, nor angels nor principalities nor powers, nor things present nor things to come,</p>
<p id="pz19-10">nor height nor depth, nor any other created thing, shall be able to separate us from the love of God which is in Christ Jesus our Lord.</p>
<p class="right" id="pz19-13"><em>Romans 8:38, 39</em></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter03.vue?1f5a1ffb